export default "__VITE_ASSET__CCorOSXH__"